import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { Badge } from "@/components/Badge";
import { TenderMigrationModal } from "@/pages/Tenders/TenderMigrationModal";

export const TenderMigration: React.FC = () => {
    const { t } = useTranslation("global");
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleOpenModal = (): void => {
        setIsOpen(true);
    };

    const handleCloseModal = (): void => {
        setIsOpen(false);
    };

    return (
        <>
            <div
                onClick={handleOpenModal}
                className="flex flex-col items-center justify-center bg-white p-6 rounded-xl border border-gray-200 shadow-sm cursor-pointer hover:border-primary/50 hover:shadow-md transition-all group dark:bg-dark-card dark:border-white/10"
            >
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon
                        value="database"
                        size={24}
                        color="primary"
                        background
                    />
                </div>
                <h2 className="text-sm font-medium text-gray-900 text-center dark:text-white">
                    {t("tools.tender_migration.title")}
                </h2>
                <p className="text-xs text-gray-500 text-center mt-1 dark:text-zinc-400 line-clamp-2">
                    {t("tools.tender_migration.card_desc")}
                </p>
                <div className="mt-3">
                    <Badge variant="neutral" pill={false}>
                        {t("tools.tender_migration.status_badge")}
                    </Badge>
                </div>
            </div>

            <TenderMigrationModal isOpen={isOpen} onClose={handleCloseModal} />
        </>
    );
};
